// import { useEffect, useState } from 'react';
// import { ArrowRight, BarChart3, Target, Users, Zap, Database } from 'lucide-react';
// import './Services.css';
// import ScrollToTop from '../../Components/Scrolltop/Scrolltop';
// import { client } from '../../contentfulClient';

// const iconMap = {
//   'applied-research': <BarChart3 size={56} />,
//   merl: <Target size={56} />,
//   'implementation-research': <Zap size={56} />,
//   'data-analytics': <Database size={56} />,
//   'strategy-governance': <Zap size={56} />,
//   'knowledge-translation': <Users size={56} />,
// };

// const Services = () => {
//   const [pageData, setPageData] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await client.getEntries({
//           content_type: 'servicePage',
//           limit: 1,
//         });

//         if (response.items.length > 0) {
//           const servicesPage = response.items[0];
//           const servicesIds = servicesPage.fields.services.map(s => s.sys.id);

//           // Fetch linked service entries
//           const servicesResponse = await client.getEntries({
//             content_type: 'service',
//             'sys.id[in]': servicesIds.join(','),
//           });

//           setPageData({
//             heroTitle: servicesPage.fields.heroTitle,
//             heroDescription: servicesPage.fields.heroDescription,
//             ctaTitle: servicesPage.fields.ctaTitle,
//             ctaButtonText: servicesPage.fields.ctaButtonText,
//             ctaButtonLink: servicesPage.fields.ctaButtonLink,
//             services: servicesResponse.items,
//           });
//         }
//       } catch (error) {
//         console.error('Error fetching Contentful data:', error);
//       }
//     };

//     fetchData();
//   }, []);

//   if (!pageData) return <div>Loading...</div>;

//   return (
//     <>
//       <ScrollToTop />

//       {/* ==================== HERO ==================== */}
//       <section className="hero hero-services">
//         <div className="container">
//           <h1>{pageData.heroTitle}</h1>
//           <p>{pageData.heroDescription}</p>
//           <div className="hero-buttons">
//             <a href="#research" className="btn btn-primary">
//               Explore Services <ArrowRight />
//             </a>
//             <a href="/sectors" className="btn btn-secondary">
//               Thematic Focus Areas
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* ==================== SERVICES ==================== */}
//       <section className="section services-grid">
//         <div className="container">
//           <div className="services-grid-wrapper">
//             {pageData.services.map(service => {
//               const { title, slug, description, keyServices, readMoreLink } = service.fields;
//               return (
//                 <div id={slug} key={slug} className="service-card">
//                   <div className="service-icon">{iconMap[slug]}</div>
//                   <h3>{title}</h3>
//                   <p>{description}</p>
//                   <p><strong>Key services include:</strong></p>
//                   <ul>
//                     {keyServices.map((item, idx) => (
//                       <li key={idx}>{item}</li>
//                     ))}
//                   </ul>
//                   <a href={readMoreLink} className="service-link">
//                     Read More <ArrowRight size={20} />
//                   </a>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* ==================== CTA ==================== */}
//       <section className="final-cta">
//         <div className="container text-center">
//           <h2>{pageData.ctaTitle}</h2>
//           <a href={pageData.ctaButtonLink} className="btn btn-primary">
//             {pageData.ctaButtonText} <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer remains unchanged */}

//              <footer className="footer">
//          <div className="footer-grid">
//            <div>
//              <div className="footer-logo">DevLearn Impact Research Ltd</div>
//              <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//              <p>+260 973 902 981 / +260 978 341 825</p>
//              <p>info@devlearnimpact.com</p>
//            </div>
//            <div>
//              <h4>Services</h4>
//              <ul>
//                <li><a href="/services">Applied Research</a></li>
//                <li><a href="/services">MERL Frameworks</a></li>
//                <li><a href="/services">Capacity Building</a></li>
//              </ul>
//            </div>
//            <div>
//              <h4>Thematic Areas</h4>
//              <ul>
//                <li><a href="/sectors">Education & Health</a></li>
//                <li><a href="/sectors">Governance & Climate</a></li>
//                <li><a href="/sectors">Economic Inclusion</a></li>
//              </ul>
//            </div>
//            <div>
//              <h4>Company</h4>
//              <ul>
//                <li><a href="/about">About</a></li>
//                <li><a href="/team">Team</a></li>
//                <li><a href="/case-studies">Projects</a></li>
//              </ul>
//            </div>
//            <div>
//              <h4>Connect</h4>
//              <ul>
//                <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//                <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//              </ul>
//            </div>
//          </div>
//          <div className="copyright">
//            © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//          </div>
//        </footer>
      
     
//     </>
//   );
// };

// export default Services;
import {
  ArrowRight,
  BarChart3,
  Target,
  Users,
  Zap,
  Database,
} from 'lucide-react';
import './Services.css';
import ScrollToTop from '../../Components/Scrolltop/Scrolltop';

const Services = () => {
  <ScrollToTop />
  return (
    <>
      {/* ==================== HERO ==================== */}
      <section className="hero hero-services">
        <div className="container">
          <h1>Our Research Services</h1>
          <p>
            End-to-end evidence-driven solutions in MERL, research, and capacity
            building. We deliver rigorous, context-specific services that empower
            inclusive decision-making and sustainable impact.
          </p>
          <div className="hero-buttons">
            <a href="#research" className="btn btn-primary">
              Explore Services <ArrowRight />
            </a>
            <a href="/sectors" className="btn btn-secondary">
              Thematic Focus Areas
            </a>
          </div>
        </div>
      </section>

      {/* ==================== SERVICES ==================== */}
      <section className="section services-grid">
        <div className="container">
          <div className="services-grid-wrapper">

            <div id="research" className="service-card">
              <div className="service-icon">
                <BarChart3 size={56} />
              </div>
              <h3>Applied Research, Evaluation & Policy Analysis</h3>
              <p>
                We design and deliver rigorous, context-responsive research and evaluations to inform policy, programming, and systems reform. Our work integrates mixed-methods, political economy analysis, quasi-experimental and experimental designs, and equity-focused approaches to generate actionable evidence.
              </p>
              <p><strong>Key services include:</strong></p>
              <ul>
                <li>Baseline, midline, endline, and impact evaluations</li>
                <li>Political economy and institutional analysis</li>
                <li>Gender, youth, and social inclusion studies</li>
                <li>Policy research and programme learning reviews</li>
                <li>Evidence synthesis and rapid assessments</li>
              </ul>
              <a href="/services/applied-research" className="service-link">
                Read More <ArrowRight size={20} />
              </a>
            </div>

            <div id="merl" className="service-card">
              <div className="service-icon">
                <Target size={56} />
              </div>
              <h3>Monitoring, Evaluation, Research & Learning (MERL) Systems</h3>
              <p>
                We design and operationalise robust MERL systems that support accountability, performance management, and evidence-informed decision-making across the project cycle.
              </p>
              <p><strong>Key services include:</strong></p>
              <ul>
                <li>Theory of Change and Results Framework design</li>
                <li>Indicator development and data quality assurance systems</li>
                <li>Outcome harvesting and contribution analysis</li>
                <li>Digital data collection systems (Kobo, SurveyCTO, ODK)</li>
                <li>Learning and reflection platforms for adaptive programming</li>
              </ul>
              <a href="/services/merl" className="service-link">
                Read More <ArrowRight size={20} />
              </a>
            </div>

            <div id="implementation" className="service-card">
              <div className="service-icon">
                <Zap size={56} />
              </div>
              <h3>Implementation Research & Adaptive Learning</h3>
              <p>
                We support partners to generate real-time evidence on what works, for whom, and under what conditions during implementation. Our approach strengthens adaptive management, continuous improvement, and learning cultures.
              </p>
              <p><strong>Key services include:</strong></p>
              <ul>
                <li>Embedded learning and adaptive management frameworks</li>
                <li>Process evaluations and fidelity assessments</li>
                <li>Rapid-cycle learning and real-time feedback loops</li>
                <li>Pilot testing, prototyping, and scale-readiness assessments</li>
                <li>Learning agendas and implementation dashboards</li>
              </ul>
              <a href="/services/implementation-research" className="service-link">
                Read More <ArrowRight size={20} />
              </a>
            </div>

            <div id="analytics" className="service-card">
              <div className="service-icon">
                <Database size={56} />
              </div>
              <h3>Data Analytics, Digital Solutions & Systems Strengthening</h3>
              <p>
                We apply advanced analytics and digital tools to strengthen institutional systems, improve targeting, forecasting, and performance management, and enable data-driven transformation.
              </p>
              <p><strong>Key services include:</strong></p>
              <ul>
                <li>Advanced statistical modelling and predictive analytics</li>
                <li>Dashboards, data visualisation, and performance tracking systems</li>
                <li>Data governance, integration, and management systems</li>
                <li>Institutional data system audits and digital transformation roadmaps</li>
                <li>Capacity building in R, STATA, SPSS, Power BI, and Python</li>
              </ul>
              <a href="/services/data-analytics" className="service-link">
                Read More <ArrowRight size={20} />
              </a>
            </div>

            <div id="strategy" className="service-card">
              <div className="service-icon">
                <Zap size={56} />
              </div>
              <h3>Strategy, Governance & Institutional Capacity Development</h3>
              <p>
                We support organisations and public institutions to strengthen governance, strategy, and operational systems for sustainable and inclusive impact.
              </p>
              <p><strong>Key services include:</strong></p>
              <ul>
                <li>Organisational assessments and governance diagnostics</li>
                <li>Strategic planning and results-based management</li>
                <li>Programme and business model design</li>
                <li>Change management and leadership coaching</li>
                <li>Policy and institutional reform advisory</li>
              </ul>
              <a href="/services/strategy-governance" className="service-link">
                Read More <ArrowRight size={20} />
              </a>
            </div>

            <div id="knowledge" className="service-card">
              <div className="service-icon">
                <Users size={56} />
              </div>
              <h3>Knowledge Translation, Learning & Influence</h3>
              <p>
                We ensure evidence is accessible, usable, and influential by transforming data into compelling knowledge products and learning processes that drive change.
              </p>
              <p><strong>Key services include:</strong></p>
              <ul>
                <li>Policy briefs, learning reports, and infographics</li>
                <li>Data storytelling and visual analytics</li>
                <li>Stakeholder learning forums and convenings</li>
                <li>Knowledge management systems</li>
                <li>Advocacy and evidence-to-policy pathways</li>
              </ul>
              <a href="/services/knowledge-translation" className="service-link">
                Read More <ArrowRight size={20} />
              </a>
            </div>

          </div>
        </div>
      </section>

      {/* ==================== CTA ==================== */}
      <section className="final-cta">
        <div className="container text-center">
          <h2>
            Ready to Launch an Evidence-Driven Initiative?
            <br />
            Let’s Measure What Matters.
          </h2>
          <a href="/contact" className="btn btn-primary">
            Start a Project <ArrowRight size={28} />
          </a>
        </div>
      </section>

      {/* Footer remains unchanged - you can keep your existing footer */}
             {/* Footer */}
       <footer className="footer">
         <div className="footer-grid">
           <div>
             <div className="footer-logo">DevLearn Impact Research Ltd</div>
             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
             <p>+260 973 902 981 / +260 978 341 825</p>
             <p>info@devlearnimpact.com</p>
           </div>
           <div>
             <h4>Services</h4>
             <ul>
               <li><a href="/services">Applied Research</a></li>
               <li><a href="/services">MERL Frameworks</a></li>
               <li><a href="/services">Capacity Building</a></li>
             </ul>
           </div>
           <div>
             <h4>Thematic Areas</h4>
             <ul>
               <li><a href="/sectors">Education & Health</a></li>
               <li><a href="/sectors">Governance & Climate</a></li>
               <li><a href="/sectors">Economic Inclusion</a></li>
             </ul>
           </div>
           <div>
             <h4>Company</h4>
             <ul>
               <li><a href="/about">About</a></li>
               <li><a href="/team">Team</a></li>
               <li><a href="/case-studies">Projects</a></li>
             </ul>
           </div>
           <div>
             <h4>Connect</h4>
             <ul>
               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
             </ul>
           </div>
         </div>
         <div className="copyright">
           © 2026 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
         </div>
       </footer>
    </>
  );
};

export default Services;

// import {
//   ArrowRight,
//   BarChart3,
//   Target,
//   Users,
//   Zap,
//   Database,
// } from 'lucide-react';
// import './Services.css';

// const Services = () => {
//   return (
//     <>
//       {/* ==================== HERO ==================== */}
//       <section className="hero hero-services">
//         <div className="container">
//           <h1>Our Research Services</h1>
//           <p>
//             End-to-end evidence-driven solutions in MERL, research, and capacity
//             building. We deliver rigorous, context-specific services that empower
//             inclusive decision-making and sustainable impact.
//           </p>
//           <div className="hero-buttons">
//             <a href="#research" className="btn btn-primary">
//               Explore Services <ArrowRight />
//             </a>
//             <a href="/sectors" className="btn btn-secondary">
//               Thematic Focus Areas
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* ==================== SERVICES ==================== */}
//       <section className="section services-grid">
//         <div className="container">
//           <div className="services-grid-wrapper">

//             <div id="research" className="service-card">
//               <div className="service-icon">
//                 <BarChart3 size={56} />
//               </div>
//               <h3>Applied Research & Policy Analysis</h3>
//               <p>
//                 Rigorous mixed-methods research, impact evaluations, political
//                 economy analysis, and gender-sensitive studies integrating
//                 analytics and systems thinking.
//               </p>
//             </div>

//             <div id="merl" className="service-card">
//               <div className="service-icon">
//                 <Target size={56} />
//               </div>
//               <h3>Monitoring, Evaluation, Research & Learning (MERL)</h3>
//               <p>
//                 Design and implementation of MERL systems including baselines,
//                 outcome harvesting, real-time monitoring, learning loops, and
//                 visualization dashboards.
//               </p>
//             </div>

//             <div id="capacity" className="service-card">
//               <div className="service-icon">
//                 <Users size={56} />
//               </div>
//               <h3>Institutional & Capacity Development</h3>
//               <p>
//                 Tailored training, coaching, and systems strengthening using
//                 tools such as STATA, R, SPSS, KoboToolbox, and SurveyCTO.
//               </p>
//             </div>

//             <div id="strategy" className="service-card">
//               <div className="service-icon">
//                 <Zap size={56} />
//               </div>
//               <h3>Strategy Design & Technical Assistance</h3>
//               <p>
//                 Strategic planning, program design, governance advisory, digital
//                 transformation, and adaptive implementation support.
//               </p>
//             </div>

//             <div id="knowledge" className="service-card">
//               <div className="service-icon">
//                 <Database size={56} />
//               </div>
//               <h3>Knowledge Translation & Learning</h3>
//               <p>
//                 Policy briefs, infographics, learning events, and digital
//                 storytelling that transform evidence into action.
//               </p>
//             </div>

//           </div>
//         </div>
//       </section>

//       {/* ==================== CTA ==================== */}
//       <section className="final-cta">
//         <div className="container text-center">
//           <h2>
//             Ready to Launch an Evidence-Driven Initiative?
//             <br />
//             Let’s Measure What Matters.
//           </h2>
//           <a href="/contact" className="btn btn-primary">
//             Start a Project <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//        {/* Footer */}
//        <footer className="footer">
//          <div className="footer-grid">
//            <div>
//              <div className="footer-logo">DevLearn Impact Research Ltd</div>
//              <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//              <p>+260 973 902 981 / +260 978 341 825</p>
//              <p>info@devlearnimpact.com</p>
//            </div>
//            <div>
//              <h4>Services</h4>
//              <ul>
//                <li><a href="/services">Applied Research</a></li>
//                <li><a href="/services">MERL Frameworks</a></li>
//                <li><a href="/services">Capacity Building</a></li>
//              </ul>
//            </div>
//            <div>
//              <h4>Thematic Areas</h4>
//              <ul>
//                <li><a href="/sectors">Education & Health</a></li>
//                <li><a href="/sectors">Governance & Climate</a></li>
//                <li><a href="/sectors">Economic Inclusion</a></li>
//              </ul>
//            </div>
//            <div>
//              <h4>Company</h4>
//              <ul>
//                <li><a href="/about">About</a></li>
//                <li><a href="/team">Team</a></li>
//                <li><a href="/case-studies">Projects</a></li>
//              </ul>
//            </div>
//            <div>
//              <h4>Connect</h4>
//              <ul>
//                <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//                <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//              </ul>
//            </div>
//          </div>
//          <div className="copyright">
//            © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//          </div>
//        </footer>
//     </>
//   );
// };

// export default Services;



// // pages/Services/Services.jsx - Full DevLearn-branded Services page
// import { ArrowRight, BarChart3, Zap, Database, Target, Users } from 'lucide-react';
// import './Services.css';

// const Services = () => {
//   return (
//     <>
//       {/* Hero */}
//       <section className="hero hero-services">
//         <div className="container">
//           <h1>Our Research Services</h1>
//           <p>
//             End-to-end evidence-driven solutions in MERL, research, and capacity building. 
//             We deliver rigorous, context-specific services to empower inclusive decision-making 
//             and sustainable impact for public and private sector clients.
//           </p>
//           <div className="hero-buttons">
//             <a href="#services" className="btn btn-primary">
//               Discover Services <ArrowRight />
//             </a>
//             <a href="/sectors" className="btn btn-secondary">
//               Thematic Focus Areas
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Introduction */}
//       <section className="section intro">
//         <div className="container">
//           <div className="text-center">
//             <h2>Comprehensive Expertise for Development Impact</h2>
//             <p className="lead">
//               From applied research to knowledge translation, our services integrate advanced tools (STATA, R, KoboToolbox) 
//               with participatory approaches to support learning, adaptation, and accountability.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Services Grid */}
//       <section id="services" className="section services-grid">
//         <div className="container">
//           <div className="services-grid-wrapper">
//             {[
//               {
//                 icon: BarChart3,
//                 title: 'Applied Research & Policy Analysis',
//                 desc: 'Rigorous mixed-methods studies, political economy analysis, impact evaluations, and gender-sensitive research. We integrate data analytics and mathematical modeling to generate insights and support systems thinking.'
//               },
//               {
//                 icon: Target,
//                 title: 'Monitoring, Evaluation, Research & Learning (MERL)',
//                 desc: 'Design and implement MERL frameworks for learning, adaptation, and accountability. Services include baseline studies, outcome harvesting, real-time monitoring, predictive analytics, and data visualization with quality assurance.'
//               },
//               {
//                 icon: Users,
//                 title: 'Institutional & Capacity Development',
//                 desc: 'Strengthen capacities through tailored training, coaching, and systems reviews. Focus on sustainable change in MERL systems, project design, and tools like STATA, R, SPSS, KoboToolbox, and SurveyCTO for NGOs and public bodies.'
//               },
//               {
//                 icon: Zap,
//                 title: 'Strategy Design & Technical Assistance',
//                 desc: 'Support strategic planning, program design, and operational alignment. Facilitate inclusive processes and provide advisory on governance, economic inclusion, digital transformation, adaptive implementation, and project management.'
//               },
//               {
//                 icon: Database,
//                 title: 'Knowledge Translation & Learning Events',
//                 desc: 'Turn evidence into action via policy briefs, infographics, learning convenings, and digital storytelling. Our participatory events foster shared learning, influence, and adaptive practice for continuous improvement.'
//               },
//             ].map((service, idx) => (
//               <div key={idx} className="service-card">
//                 <div className="service-icon">
//                   <service.icon size={56} className="icon-primary" />
//                 </div>
//                 <h3>{service.title}</h3>
//                 <p>{service.desc}</p>
//                 <a href="#" className="service-link">Explore Details <ArrowRight size={20} /></a>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Why Choose Us */}
//       <section className="section why-us">
//         <div className="container text-center">
//           <h2>Why Partner With DevLearn</h2>
//           <p className="lead">
//             Guided by our three pillars—Facilitation, Linkage, and Partnership—we deliver excellence through integrity, innovation, and inclusion.
//           </p>
//           <div className="why-grid">
//             {[
//               {
//                 title: 'Local Ownership & Evidence-Based',
//                 desc: 'Co-created solutions anchored in high-quality data and community empowerment.'
//               },
//               {
//                 title: 'Inclusive & Adaptive',
//                 desc: 'Embedding gender equity, youth voice, and social inclusion in every step.'
//               },
//               {
//                 title: 'Scalable Impact',
//                 desc: 'From Zambia to Africa-wide, fostering systems transformation through rigorous MERL.'
//               }
//             ].map((item, idx) => (
//               <div key={idx} className="why-item">
//                 <h3>{item.title}</h3>
//                 <p>{item.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="final-cta text-center">
//         <div className="container">
//           <h2>
//             Ready to Launch Your Evidence-Driven Initiative?<br />Let's Measure What Matters Together.
//           </h2>
//           <a href="/contact" className="btn btn-primary">
//             Start a Project <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="footer">
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo">DevLearn Impact Research Ltd</div>
//             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p>+260 973 902 981 / +260 978 341 825</p>
//             <p>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="/services">Applied Research</a></li>
//               <li><a href="/services">MERL Frameworks</a></li>
//               <li><a href="/services">Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors">Education & Health</a></li>
//               <li><a href="/sectors">Governance & Climate</a></li>
//               <li><a href="/sectors">Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="/case-studies">Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright">
//           © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Services;


// // pages/Services/Services.jsx - Services page adapted for DevLearn (from PDF pages 7-8)
// import { ArrowRight, BarChart3, Zap, Database, Target, Users } from 'lucide-react';
// import './Services.css'; // Shared global styles with palette

// const Services = () => {
//   return (
//     <>
//       {/* Hero */}
//       <section className="hero" style={{ background: 'linear-gradient(180deg, #F0F9FF 0%, #ffffff 100%)' }}>
//         <div className="container">
//           <h1 style={{ color: '#1E3A8A' }}>Our Research Services</h1>
//           <p>
//             End-to-end evidence-driven solutions in MERL, research, and capacity building. We deliver rigorous, context-specific services to empower inclusive decision-making and sustainable impact for public and private sector clients.
//           </p>
//           <div className="hero-buttons">
//             <a href="#services" className="btn btn-primary">
//               Discover Services <ArrowRight />
//             </a>
//             <a href="/sectors" className="btn btn-secondary">
//               Thematic Focus Areas
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Introduction */}
//       <section className="section intro">
//         <div className="container">
//           <div className="text-center">
//             <h2 style={{ color: '#1E3A8A' }}>Comprehensive Expertise for Development Impact</h2>
//             <p className="lead">
//               From applied research to knowledge translation, our services integrate advanced tools (STATA, R, KoboToolbox) with participatory approaches to support learning, adaptation, and accountability.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Services Grid - From PDF */}
//       <section id="services" className="section services-grid">
//         <div className="container">
//           <div className="services-grid-wrapper">
//             <div className="service-card">
//               <div className="service-icon">
//                 <BarChart3 size={56} style={{ color: '#0D9488' }} />
//               </div>
//               <h3 style={{ color: '#1E3A8A' }}>Applied Research & Policy Analysis</h3>
//               <p>
//                 Rigorous mixed-methods studies, political economy analysis, impact evaluations, and gender-sensitive research. We integrate data analytics and mathematical modeling to generate insights and support systems thinking.
//               </p>
//               <a href="#" className="service-link">Explore Details <ArrowRight size={20} /></a>
//             </div>
//             <div className="service-card">
//               <div className="service-icon">
//                 <Target size={56} style={{ color: '#0D9488' }} />
//               </div>
//               <h3 style={{ color: '#1E3A8A' }}>Monitoring, Evaluation, Research & Learning (MERL)</h3>
//               <p>
//                 Design and implement MERL frameworks for learning, adaptation, and accountability. Services include baseline studies, outcome harvesting, real-time monitoring, predictive analytics, and data visualization with quality assurance.
//               </p>
//               <a href="#" className="service-link">Explore Details <ArrowRight size={20} /></a>
//             </div>
//             <div className="service-card">
//               <div className="service-icon">
//                 <Users size={56} style={{ color: '#0D9488' }} />
//               </div>
//               <h3 style={{ color: '#1E3A8A' }}>Institutional & Capacity Development</h3>
//               <p>
//                 Strengthen capacities through tailored training, coaching, and systems reviews. Focus on sustainable change in MERL systems, project design, and tools like STATA, R, SPSS, KoboToolbox, and SurveyCTO for NGOs and public bodies.
//               </p>
//               <a href="#" className="service-link">Explore Details <ArrowRight size={20} /></a>
//             </div>
//             <div className="service-card">
//               <div className="service-icon">
//                 <Zap size={56} style={{ color: '#0D9488' }} />
//               </div>
//               <h3 style={{ color: '#1E3A8A' }}>Strategy Design & Technical Assistance</h3>
//               <p>
//                 Support strategic planning, program design, and operational alignment. Facilitate inclusive processes and provide advisory on governance, economic inclusion, digital transformation, adaptive implementation, and project management.
//               </p>
//               <a href="#" className="service-link">Explore Details <ArrowRight size={20} /></a>
//             </div>
//             <div className="service-card">
//               <div className="service-icon">
//                 <Database size={56} style={{ color: '#0D9488' }} />
//               </div>
//               <h3 style={{ color: '#1E3A8A' }}>Knowledge Translation & Learning Events</h3>
//               <p>
//                 Turn evidence into action via policy briefs, infographics, learning convenings, and digital storytelling. Our participatory events foster shared learning, influence, and adaptive practice for continuous improvement.
//               </p>
//               <a href="#" className="service-link">Explore Details <ArrowRight size={20} /></a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Why Choose Us - Tied to Core Values/Approach */}
//       <section className="section why-us bg-light" style={{ background: '#F0F9FF' }}>
//         <div className="container">
//           <div className="text-center">
//             <h2 style={{ color: '#1E3A8A' }}>Why Partner With DevLearn</h2>
//             <p className="lead">
//               Guided by our three pillars—Facilitation, Linkage, and Partnership—we deliver excellence through integrity, innovation, and inclusion.
//             </p>
//           </div>
//           <div className="why-grid">
//             <div className="why-item">
//               <h3 style={{ color: '#1E3A8A' }}>Local Ownership & Evidence-Based</h3>
//               <p>Co-created solutions anchored in high-quality data and community empowerment.</p>
//             </div>
//             <div className="why-item">
//               <h3 style={{ color: '#1E3A8A' }}>Inclusive & Adaptive</h3>
//               <p>Embedding gender equity, youth voice, and social inclusion in every step.</p>
//             </div>
//             <div className="why-item">
//               <h3 style={{ color: '#1E3A8A' }}>Scalable Impact</h3>
//               <p>From Zambia to Africa-wide, fostering systems transformation through rigorous MERL.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="final-cta text-center" style={{ background: '#1E3A8A', color: '#fff' }}>
//         <div className="container">
//           <h2>
//             Ready to Launch Your Evidence-Driven Initiative?<br />Let's Measure What Matters Together.
//           </h2>
//           <a href="/contact" className="btn btn-primary" style={{ background: '#fff', color: '#1E3A8A' }}>
//             Start a Project <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer - Reused with DevLearn details */}
//       <footer className="footer" style={{ background: '#111827' }}>
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo" style={{ color: '#0D9488' }}>DevLearn Impact Research Ltd</div>
//             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p>+260 973 902 981 / +260 978 341 825</p>
//             <p>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Services</h4>
//             <ul>
//               <li><a href="/services">Applied Research</a></li>
//               <li><a href="/services">MERL Frameworks</a></li>
//               <li><a href="/services">Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors">Education & Health</a></li>
//               <li><a href="/sectors">Governance & Climate</a></li>
//               <li><a href="/sectors">Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="/case-studies">Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright" style={{ color: '#9CA3AF' }}>
//           © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Services;
// // pages/Services/Services.jsx - Services page
// import { ArrowRight, BarChart3, Zap, Database, Target } from 'lucide-react';
// import '../../index.css'; // Shared global styles
// import './Services.css'; // Page-specific styles

// const Services = () => {
//   return (
//     <>
//       {/* Hero */}
//       <section className="hero">
//         <div className="container">
//           <h1>Our Research Services</h1>
//           <p>
//             End-to-end solutions from data gathering to strategic advisory. We specialize in delivering
//             precise, evidence-based research that powers informed decisions and measurable outcomes.
//           </p>
//           <div className="hero-buttons">
//             <a href="#services" className="btn btn-primary">
//               Discover Services <ArrowRight />
//             </a>
//             <a href="/sectors" className="btn btn-secondary">
//               By Sector
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Introduction */}
//       <section className="section intro">
//         <div className="container">
//           <div className="text-center">
//             <h2>Comprehensive Research Expertise</h2>
//             <p className="lead">
//               Whether you're launching a new initiative or evaluating existing programs, our services
//               combine methodological rigor with practical application to yield insights that matter.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Services Grid */}
//       <section id="services" className="section services-grid">
//         <div className="container">
//           <div className="services-grid-wrapper">
//             <div className="service-card">
//               <div className="service-icon">
//                 <BarChart3 size={56} />
//               </div>
//               <h3>Market Research</h3>
//               <p>
//                 Uncover consumer behaviors, market trends, and competitive landscapes through surveys,
//                 focus groups, and advanced analytics to guide product development and strategy.
//               </p>
//               <div className="service-stats">
//                 <span>300+</span>
//                 <span>Market Studies</span>
//               </div>
//               <a href="#" className="service-link">Explore Details <ArrowRight size={20} /></a>
//             </div>
//             <div className="service-card">
//               <div className="service-icon">
//                 <Target size={56} />
//               </div>
//               <h3>Impact Evaluation</h3>
//               <p>
//                 Measure the effectiveness of interventions using randomized controlled trials (RCTs),
//                 quasi-experimental designs, and mixed-methods to demonstrate real-world value.
//               </p>
//               <div className="service-stats">
//                 <span>250+</span>
//                 <span>Evaluations</span>
//               </div>
//               <a href="#" className="service-link">Explore Details <ArrowRight size={20} /></a>
//             </div>
//             <div className="service-card">
//               <div className="service-icon">
//                 <Database size={56} />
//               </div>
//               <h3>Data Analytics</h3>
//               <p>
//                 Transform raw data into actionable intelligence with statistical modeling, machine
//                 learning, and visualization tools tailored to your organizational needs.
//               </p>
//               <div className="service-stats">
//                 <span>400+</span>
//                 <span>Datasets Analyzed</span>
//               </div>
//               <a href="#" className="service-link">Explore Details <ArrowRight size={20} /></a>
//             </div>
//             <div className="service-card">
//               <div className="service-icon">
//                 <Zap size={56} />
//               </div>
//               <h3>Strategic Consulting</h3>
//               <p>
//                 Bridge research findings to business strategy with workshops, policy briefs, and
//                 advisory sessions that align evidence with your long-term goals.
//               </p>
//               <div className="service-stats">
//                 <span>180+</span>
//                 <span>Consulting Engagements</span>
//               </div>
//               <a href="#" className="service-link">Explore Details <ArrowRight size={20} /></a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Why Choose Us */}
//       <section className="section why-us bg-light">
//         <div className="container">
//           <div className="text-center">
//             <h2>Why Partner With Us</h2>
//             <p className="lead">
//               Our services are built on a foundation of global standards, innovative tools, and a
//               commitment to ethical research that delivers lasting impact.
//             </p>
//           </div>
//           <div className="why-grid">
//             <div className="why-item">
//               <h3>Customized Methodologies</h3>
//               <p>Tailored approaches that fit your context, timeline, and objectives.</p>
//             </div>
//             <div className="why-item">
//               <h3>Expert Teams</h3>
//               <p>Multidisciplinary specialists with proven track records in complex projects.</p>
//             </div>
//             <div className="why-item">
//               <h3>Scalable Solutions</h3>
//               <p>From pilot studies to nationwide implementations, we scale with you.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="final-cta text-center">
//         <div className="container">
//           <h2>
//             Ready to launch your next research project?<br />Let's turn your questions into answers.
//           </h2>
//           <a href="/contact" className="btn btn-primary">
//             Start a Project <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer - Reused for consistency */}
//       <footer className="footer">
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo">InSight Research</div>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="#">Market Research</a></li>
//               <li><a href="#">Impact Evaluation</a></li>
//               <li><a href="#">Data Analytics</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Sectors</h4>
//             <ul>
//               <li><a href="/sectors#education">Education</a></li>
//               <li><a href="/sectors#health">Public Health</a></li>
//               <li><a href="/sectors#finance">Finance & Development</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="#">Team</a></li>
//               <li><a href="#">Reports</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Contact</h4>
//             <ul>
//               <li><a href="/contact">hello@insightresearch.com</a></li>
//               <li><a href="#">Locations</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright">
//           © 2025 InSight Research. All rights reserved.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Services;